import Login from'./Login'
import CreateAnAccount from'./CreateAnAccount'
import Register from './register'
import LoginModalApp from'./LoginModalApp'
import ModalLogin from'./ModalLogin'

export default {
    'create-an-account': CreateAnAccount,
    'login': Login,
    'login-modal-app': LoginModalApp,
    'modal-login': ModalLogin,
    ...Register
}
